export const removeWhiteSpaces = (str: string) => str.replaceAll(' ', '');
